import {isPlastyvergTenant} from 'src/modules/tarea/dynamicSubsectionPdfGrouping';
import Permissions from 'src/security/permissions';
import Roles from 'src/security/roles';

const dashboardRead = Permissions.values.dashboardRead;

/** En Plastyverg el menú/ruta Dashboard exige el rol fijo `dashboard`, no dashboardRead. */
export function dashboardMenuPermission(tenantId?: string | null) {
  if (isPlastyvergTenant(tenantId)) {
    return {
      id: 'plastyvergDashboardRole',
      allowedRoles: [Roles.values.dashboard],
      allowedPlans: dashboardRead.allowedPlans,
    };
  }
  return dashboardRead;
}

export function canAccessDashboardMenu(tenantId: string | null | undefined, roles: unknown): boolean {
  if (!isPlastyvergTenant(tenantId)) {
    return true;
  }
  return Array.isArray(roles) && roles.includes(Roles.values.dashboard);
}
